import React,{ useEffect, useState } from 'react'
import AdminListing from '../../../common/adminListing'
import SearchBar from '../../../common/commonSearchBar';
import { holidaysbookingStatusValues } from '../../../resources/status';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../../../common/pagination';
import CommonMoreInfoModel from '../../../common/commonMoreInfoModel';
import ConfirmRefundModal from '../../../common/confirmRefundModel';

import { 
    getHolidayBookingList, 
    holidayBookingsSearch, 
    holidayBookingStatusUpdate,
    pageId,
    holidayBookingSearchValue
} from '../../../actions/holidayBookingAction';
import {
    getExperienceBookingList,
    experienceBookingsSearch,
    experienceBookingStatusUpdate,
    // pageId,
    experienceSearchValue
} from '../../../actions/experienceBookingAction';
import ClosedModal from '../closeRequestModal';
import { checkNumberOfGuest, isCorporate} from '../../../utils/index';
import { closeRequestInputVal } from '../../../actions/holidayRequestAction';

import moment from 'moment'
const Refunded = () => {
    const [ showMoreInfo, setShowMoreInfo ] = useState(false);
    const [ moreInfoData, setMoreInfoData ] = useState({});
    const [ searchVal, setSearchVal ] = useState('');
    const [ pageVal, setPageVal ] = useState(1);
    const [status, setStatus] = useState('');
    const [id, setId] = useState(null);
    const[iscopr,setIscorp]=useState()
    const [ statusChangeBool, setStatusChangeBool ] = useState(false);
    const[averageBookingAmount,setAverageBookingAmount]=useState()
    const[totalbookingAmount,setTotalbookingAmount]=useState()
    const [requestModal, setRequestModal] = useState(false);
    const [closeRequestModalData, setCloseRequestModalData] = useState({});
    const [isclosingMessageBool, setIsclosingMessageBool] = useState(null);
   

    const holidayBooked = useSelector(state => state.experienceBooking);
    const refundedBooking = useSelector(state => state.experienceBooking.experienceRefund.results);

    console.log(refundedBooking,"refundedBooking");
    const totapPage = useSelector(state => state.experienceBooking.experienceRefund.total_pages);
    const pageNum = useSelector(state => state.experienceBooking.page);
    const sectionID = useSelector(state => state.experienceBooking.bookingsSecId);
    const holidayRefundNxtPgeId = useSelector(state => state.experienceBooking.experienceRefundNxtPgeId);
    const holidayRefundCurrentPgeId = useSelector(state => state.experienceBooking.experienceRefundCurrentpgeId);
    const holidayRefundSearchVal = useSelector(state => state.experienceBooking.experienceRefundSearchVal);
    const ffStartDate = useSelector((state) => state.experienceBooking.holidayBookingStartDate);
   const ffEndDate = useSelector((state) => state.experienceBooking.holidayookingEndDate);
   const closeRequestMessage = useSelector(state => state.holidayRequest.closeRequestMsg);
    const dispatch = useDispatch();
    useEffect(() => {
        window.scrollTo(0, 0);
        return ()=> document.body.style.overflow = 'unset';
    }, [showMoreInfo]);

    useEffect(() => {
        if(holidayRefundNxtPgeId === null && holidayRefundCurrentPgeId > 1 && refundedBooking?.length === 0) {
            dispatch(getExperienceBookingList(1, sectionID, "refunded"));
            dispatch(pageId(1));
            setPageVal(1);
        }
    }, [refundedBooking, pageVal]);

    const handlePagination = (e, value) => {
        setPageVal(value);
        if(holidayRefundSearchVal !== "" || ffStartDate !== null && ffEndDate !== null){
            dispatch(experienceBookingsSearch(value, 'refunded', holidayRefundSearchVal, sectionID, ffStartDate, ffEndDate))
            dispatch(pageId(value));
        }else{
            dispatch(getExperienceBookingList(value, sectionID, "refunded"));
            dispatch(pageId(value));
        }
    };

    const moreInfoHandler = (data) => {
        setMoreInfoData(data);
        setShowMoreInfo(true);
    };
    const handleRefund=(id)=>{
}

    const handleChange = (event) => {
        setSearchVal(event.target.value);
        dispatch(experienceBookingsSearch(1, 'refunded', event.target.value, sectionID, ffStartDate, ffEndDate))
        dispatch(experienceSearchValue(event.target.value, "refunded"))
        dispatch(pageId(1));
    };

    const refreshHolidayBooking = () => {
        if(searchVal !== '' ) {
            dispatch(experienceBookingsSearch(pageNum, 'booked', searchVal, sectionID, ffStartDate, ffEndDate));
            dispatch(getExperienceBookingList(pageNum, sectionID, "confirmed"));
            dispatch(getExperienceBookingList(pageNum, sectionID, "cancelled"));
        }else if(ffStartDate !== null && ffEndDate !== null){
            dispatch(experienceBookingsSearch(pageNum, 'confirmed', searchVal, sectionID, ffStartDate, ffEndDate));
            dispatch(experienceBookingsSearch(pageNum, 'cancelled', searchVal, sectionID, ffStartDate, ffEndDate));
            dispatch(experienceBookingsSearch(pageNum, 'booked', searchVal, sectionID, ffStartDate, ffEndDate));

        } else {
            dispatch(getExperienceBookingList(pageNum, sectionID, "booked"))
            dispatch(getExperienceBookingList(pageNum, sectionID, "confirmed"))
            dispatch(getExperienceBookingList(pageNum, sectionID, "cancelled"))
        }
    };

    const statusChangeHandler = (event, id, corporate, requestsType, data) => {
        setCloseRequestModalData(data)
        let status = event.target.value;
        setStatusChangeBool(true)
        setStatus(status);
        setId(id);
        setIscorp(corporate)
        if(status === "cancelled")setRequestModal(true);
        else{
            dispatch(experienceBookingStatusUpdate(status, id, corporate,sectionID,null, refreshHolidayBooking));
        // dispatch(getHolidayBookingList(pageNum, sectionID, "confirmed"))
        // dispatch(getHolidayBookingList(pageNum, sectionID, "cancelled"))
        dispatch(pageId(pageVal));

        }
        
    };


    useEffect(()=>{
        const data=refundedBooking?.map((elem)=>{
            return parseInt(elem.amount)
        })
        const totalamount=data?.reduce((acc,elem)=>{
            return acc+elem
        },0)
        setTotalbookingAmount(totalamount)
        setAverageBookingAmount(totalamount/refundedBooking?.length)

    },[refundedBooking])
 const holidayBookingDisplayData = refundedBooking && refundedBooking.map(data => (
        <AdminListing 
            packTitle={data.pack_title}
            address={data?.sec_name  && data?.sec_name == "International" ? data.location_country : data.address}
            amount={isCorporate(data.corporate, data.total_points, data.amount_paid)}
            schedule={Array.isArray(data.schedule) ? data.schedule.sort().map((scheduleDate, index) => {
                if (data.schedule[index] === data.schedule[data.schedule.length - 1]) {
                  return scheduleDate
                } else {
                  return `${scheduleDate}, `
                }
              }) : (typeof data.schedule === 'object' && data.schedule !== null ? `${data.schedule.from} ${data.schedule.to ? `to ${data.schedule.to}` : ""}` : (data.schedule ===  null ? "N/A" : data.schedule))}
            noOfGuest={checkNumberOfGuest(data.adults, data.children, data.infants)}
            specialRequest={data.special_request?data.special_request:"N/A"}
            messageTitle={data.special_request}
            isHolidayBooking={true}
            value={data.booking_status}
            statusValues={holidaysbookingStatusValues}
            onClick={() => moreInfoHandler(data)}
            id={data.id}
            data={data}
            refCode={data.ref_id ? `#${data.ref_id}` : "No ref id"}
            isHolidayRequest={false}
            corporate={data.corporate}
            statusChangeHandler={statusChangeHandler}
            handleRefund={handleRefund}
            status={"refunded"}
            voucher_info={data?.voucher_info}
            isRefunded={true}
       />
    ));

    const closeRequestHandler = () => {
 
        setIsclosingMessageBool(false)
        if(closeRequestMessage === "")setIsclosingMessageBool(true)
       else {
            dispatch(experienceBookingStatusUpdate(status, id, iscopr, sectionID, closeRequestMessage,refreshHolidayBooking))
          setRequestModal(false)
        }
        dispatch(closeRequestInputVal(''));
      };

    const notToCancel=()=>{
        setRequestModal(false)
        setIsclosingMessageBool(false);
    
    }

    return(
        <>
            <SearchBar
                searchVal={holidayRefundSearchVal}
                handleChange={handleChange}
            />
            {refundedBooking && refundedBooking?.length === 0 && 
             <div className="enquiry-card-holder">No Record Found!</div>
            }

    
      <p style={{display:"flex",}}><span><b>Total Order Value: {" "} {totalbookingAmount?Math.round(totalbookingAmount):""}</b> </span>

 <span style={{marginLeft:"80px"}}><b> 
 Average Order Value: {" "} {averageBookingAmount?Math.round(averageBookingAmount):""}
 </b>
  </span></p>
            {holidayBookingDisplayData}
            {showMoreInfo && 
                <CommonMoreInfoModel 
                    open={showMoreInfo}
                    modalClose={() => setShowMoreInfo(false)}
                    moreInfoData={moreInfoData}
                    isCancellationMessage={false}
                />
            }
         
            <Pagination 
                totalPage={totapPage} 
                page={pageNum} 
                onChange={(event, value) => handlePagination(event, value)}
            />
                       {requestModal && 
                <ClosedModal 
                  open={requestModal}
                  handleClose={notToCancel}
                  data={closeRequestModalData}
                  isclosingMessage={isclosingMessageBool}
                  closeRequestHandler={closeRequestHandler}
                />
              }
        </>
    );
};

export default Refunded;